import { IInitialState } from "us.collection.debtor/reducers/Debtor/Interfaces";
import { otherInformation } from "./otherInformation";
import { initialCreditSafeCompany, initialCreditSafePersonal } from "./CreditSafe";

export const initialState: IInitialState = {
  address: {
    data: [],
    isFetching: false,
  },
  creditor: {
    data: [],
    isFetching: false,
  },
  history: {
    data: [],
    isFetching: false,
  },
  other: {
    data: otherInformation,
    isFetching: false,
  },
  case: {
    data: [],
    isFetching: false,
  },
  badDebt: {
    data: [],
    isBadDebtor: false,
    isFetching: false,
  },
  credit: {
    data: {},
    isFetching: false,
  }, 
  postalcode: {
    data: [],
    isLoading: false,
    isResponse: false
  },
  municipility: {
    data: [],
    isLoading: false,
    isResponse: false
  },
  isSaving: false,
  creditSafeResult: {
      personal: initialCreditSafePersonal,
      company: initialCreditSafeCompany,
      isLoading: false
    }
};
